import { render, staticRenderFns } from "./kvkk-archived-tasks.vue?vue&type=template&id=27c8633c"
import script from "./kvkk-archived-tasks.vue?vue&type=script&lang=js"
export * from "./kvkk-archived-tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports